export const crmColumns = [
    { dataColumn: 'isMemberCenter', gridColumn: 'peMemberCenter' },
    { dataColumn: 'isRemoteDonationCenter', gridColumn: 'peRdn' },
    { dataColumn: 'screeningVirtualCrossMatchUser', gridColumn: 'peVxm' },
    { dataColumn: 'donorProtectionAddendumSigned', gridColumn: 'peDonorProtectionAddendum' },
    { dataColumn: 'kidneyForLifeActive', gridColumn: 'kflA' },
    { dataColumn: 'kidneyForLifeFullyUtilized', gridColumn: 'kflfU' },
    { dataColumn: 'partnerCenter', gridColumn: 'pcPartnerCenter' },
    { dataColumn: 'allInAddendumSigned', gridColumn: 'pcAllInAddendumSigned' },
    { dataColumn: 'voucherProgramActive', gridColumn: 'adVP' },
    { dataColumn: 'familyVoucherFullyUtilized', gridColumn: 'adFVfU' },
    { dataColumn: 'standardVoucherFullyUtilized', gridColumn: 'adSVfU' },
    { dataColumn: 'dashActive', gridColumn: 'awDash' },
    { dataColumn: 'dashFullyUtilized', gridColumn: 'awDashfU' },
    { dataColumn: 'pwlActive', gridColumn: 'awPwl' },
    { dataColumn: 'pwlFullyUtilized', gridColumn: 'awPwlfU' },
    { dataColumn: 'automatedDonorFollowUpActive', gridColumn: 'awFUP' },
    { dataColumn: 'automatedDonorFollowUpFullyUtilized', gridColumn: 'awFUPfU' },
    { dataColumn: 'homeBloodDrawCount', gridColumn: 'awCHBD' },
    { dataColumn: 'liverDashActive', gridColumn: 'awLiverDash' },
    { dataColumn: 'optInAutomatedSerologies', gridColumn: 'seroSSA' },
    { dataColumn: 'micrositesActive', gridColumn: 'dsMS' },
    { dataColumn: 'micrositesFullyUtilized', gridColumn: 'dsMSfU' },
    { dataColumn: 'completedMoreThan0PatientTrainingSessions', gridColumn: 'dsPTSGt0' },
    { dataColumn: 'completedMoreThan2PatientTrainingSessions', gridColumn: 'dsPTSGt2' },
    { dataColumn: 'offerDonorConnect', gridColumn: 'dsODC' },
    { dataColumn: 'acceptingDonorReferrals', gridColumn: 'refD' },
    { dataColumn: 'acceptingPatientReferrals', gridColumn: 'refP' },
    { dataColumn: 'isAcceptingPatientReferralsForMicrosites', gridColumn: 'refMS' },
    { dataColumn: 'AcceptingK4LPatientReferrals', gridColumn: 'refK4L' },
    { dataColumn: 'automatedCollectionsAndClearing', gridColumn: 'billACC' },
    { dataColumn: 'streamlinedBillingService', gridColumn: 'billSBS' },
    { dataColumn: 'includedInCenterListingService', gridColumn: 'otherCLS' },
    { dataColumn: 'donorShieldDirectUser', gridColumn: 'otherDSD' },
    { dataColumn: 'donorShieldDirectLiverParticipant', gridColumn: 'otherDSDL' },
    { dataColumn: 'donorShieldDirectFullyUtilized', gridColumn: 'otherDSDfU' },
    { dataColumn: 'donorCareNetworkCenter', gridColumn: 'refDCN' },
    { dataColumn: 'plDashDonorConsent', gridColumn: 'pePLDDC' },
    { dataColumn: 'billable', gridColumn: 'peBillable' }
];
